import React from "react";
import {
  Text,
  Grid,
  Code,
  Paper,
  Badge,
  Stack,
  useComputedColorScheme,
  Divider,
} from "@mantine/core";

import Markdown from "../_Common/Markdown";
import ReactTimeago from "react-timeago-i18n";
import UsageDetails from "../_Shared/UsageDetails";
import { ExecutionTimeline } from "./ExecutionTimeline";

export default function RequestViewer({ response, displayMode = "markdown" }) {
  const theme = useComputedColorScheme();

  if (!response.requests) {
    return null;
  }
  return (
    <Paper radius="sm" mb="md" p="md" withBorder>
      <Grid>
        <Grid.Col span={9}>
          <Stack>
            <Paper p="xs" bg={theme == "dark" ? "dark" : "gray.2 "} radius="md">
              <Stack>
                {response.requests.map((request) => (
                  <React.Fragment key={request.shuttleRequestId}>
                    {request.messages.map((q, idx) => (
                      <div key={request.shuttleRequestId + "msg" + idx}>
                        {displayMode == "markdown" && (
                          <Markdown
                            style={{ whiteSpace: "pre-wrap" }}
                            options={{ forceBlock: true }}
                          >
                            {q.text}
                          </Markdown>
                        )}
                        {displayMode == "mono" && (
                          <Code style={{ whiteSpace: "pre-wrap" }} block>
                            {q.text}
                          </Code>
                        )}
                        {displayMode == "raw" && (
                          <Text style={{ whiteSpace: "pre-wrap" }}>{q.text}</Text>
                        )}
                      </div>
                    ))}
                  </React.Fragment>
                ))}
              </Stack>
            </Paper>
            {response.responses.map((response, index) => (
              <Paper key={"response-" + index} p="xs" bg="light" mt="xs">
                {displayMode == "markdown" && (
                  <Markdown>
                    {response.textResponse}
                  </Markdown>
                )}
                {displayMode == "mono" && (
                  <Code style={{ whiteSpace: "pre-wrap" }} block>
                    {response.textResponse}
                  </Code>
                )}
                {displayMode == "raw" && (
                  <Text style={{ whiteSpace: "pre-wrap" }}>
                    {response.textResponse}
                  </Text>
                )}
              </Paper>
            ))}

            {response.Id && response.FlowId && (
              <>
                <Divider my="sm" label="Execution Trace" labelPosition="center" />
                <ExecutionTimeline flowId={response.FlowId} runId={response.Id} />
              </>
            )}
          </Stack>
        </Grid.Col>
        <Grid.Col span={3}>
          {response.responses.map((response, index) => (
            <React.Fragment key={"response-overview-" + index}>
              <Badge mb="xs" mr="xs" radius="sm" variant="light">
                {response.provider}
              </Badge>
              <Badge mb="xs" color="grape" radius="sm" variant="light">
                {response.model}
              </Badge>

              <Text mt="md" size="xs" fw={700} tt="uppercase" c="dark.3">
                Tokens
              </Text>
              <UsageDetails usage={response.usage} />
            </React.Fragment>
          ))}
          {response.timestamp && (
            <Text c="dimmed" mt="md" ta="right">
              <ReactTimeago date={response.timestamp} />
            </Text>
          )}
        </Grid.Col>
      </Grid>
    </Paper>
  );
}
